import ButtonVariants from "@core-components/button/ButtonVariants";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Group, Image, Stack, Text } from "@mantine/core";
import type IBasketAccount from "@modules/order/stores/models/IBasketItem.models";
import { IconTrash } from "@tabler/icons-react";
import type React from "react";

interface IBasketAccountListItemProps {
  onDelete: () => void;
  item: IBasketAccount;
  isInvalid?: boolean;
}

const BasketAccountListItem: React.FC<IBasketAccountListItemProps> = ({
  onDelete,
  item,
  isInvalid,
}) => {
  const { t } = useAppTranslation("pages.order.basket.accountListItem");
  const { t: productT } = useAppTranslation();

  const classes = {
    base: " gradient-image-[var(--image-url)] flex-1 items-end bg-cover bg-no-repeat bg-primary-darker text-primary-white md:h-auto md:items-start md:bg-none ",
    invalid: " border-2 border-red-500 rounded-lg opacity-50 ",
    handlevel: " !bg-contain ",
  };
  return (
    <Group className="hover-scale" gap={5}>
      <Text
        className="writing-vertical text-red-500"
        display={isInvalid ? "block" : "none"}
      >
        {t("unavailable")}
      </Text>
      <Group
        className={
          classes.base +
          (isInvalid && classes.invalid) +
          (item.i18nKey.includes("handlevel") && classes.handlevel)
        }
        justify="start"
        style={
          {
            "--image-url": `url(${item.imageUrl})`,
          } as React.CSSProperties
        }
        wrap="nowrap"
      >
        <Image
          className="aspect-square rounded-lg object-contain"
          loading="lazy"
          src={item.imageUrl}
          visibleFrom="md"
          w={100}
        />
        <Stack className="h-fit w-full pt-10 md:h-full md:justify-between md:pt-0">
          <Stack gap={0}>
            <Text className="font-secret-black">
              {productT(`${item.i18nKey}.basket.name`, { prefix: item.prefix })}
            </Text>
            <Text
              span
              className="font-bold font-secret text-gradient-blue-purple"
            >
              {productT(`${item.i18nKey}.basket.status`)}
            </Text>
          </Stack>
          <Group justify="space-between">
            <Text className="font-inter font-light">{item.price}€</Text>
            <ButtonVariants.ActionIcon
              showDefault={false}
              variant="transparent"
              onClick={onDelete}
            >
              <IconTrash color="#DADADA" />
            </ButtonVariants.ActionIcon>
          </Group>
        </Stack>
      </Group>
    </Group>
  );
};

export default BasketAccountListItem;
